"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterConfig = void 0;
var FilterConfig = /** @class */ (function () {
    function FilterConfig(NEW_GAME_PERIOD, UPCOMING_GAME_PERIOD, NUM_RELATED_GAMES) {
        this.NEW_GAME_PERIOD = 31;
        this.UPCOMING_GAME_PERIOD = 31;
        this.NUM_RELATED_GAMES = 3;
        this.NEW_GAME_PERIOD = NEW_GAME_PERIOD;
        this.UPCOMING_GAME_PERIOD = UPCOMING_GAME_PERIOD;
        this.NUM_RELATED_GAMES = NUM_RELATED_GAMES;
    }
    return FilterConfig;
}());
exports.FilterConfig = FilterConfig;
//# sourceMappingURL=FilterConfig.js.map